package com.starparty.app.astro0.js

import com.starparty.app.astro0.SP_Time
import com.starparty.app.astro0.events.SP_Clock
import org.w3c.dom.Window
import kotlin.js.Date

class SP_JSClock(win: Window) : SP_Clock() {

    val window = win
    var timeout: Int? = null
    var intMS:Int = 1000

    var startTimeStamp = 0.0

    override fun resetStartTime(startSPTime: SP_Time){
        startTime = startSPTime
        startTimeStamp = Date.now()
    }

    override fun start(startSPTime: SP_Time) {
        resetStartTime(startSPTime)

        if (timeout != null){
            window.clearTimeout(timeout!!)
        }
        timeout = window.setTimeout({loop()}, intMS)
    }

    override fun pause() {
        if (timeout != null) {
        window.clearTimeout(timeout!!)
        }
    }

    fun loop() {
        val nowTS = Date.now()
        var deltaT = nowTS - startTimeStamp

        timeout = window.setTimeout({loop()}, intMS)
        tick(deltaT);
    }
}